import React, { Component } from "react";
import PropTypes from "prop-types";

import autoBind from "react-autobind";

import { Row, Col } from "react-bootstrap";
import Formsy from "formsy-react";
import { Input } from "formsy-react-components";

import zxcvbn from "zxcvbn";

import AvatarMessage from "../styled/AvatarMessage";

class ChangePassForm extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      newPassword: "",
      verifyPassword: "",
      canSubmit: false,
      strength: -1
    };

    this.minStrength = 4;

    autoBind(this);
  }

  onChange = (field, value) => {
    this.setState({
      [field]: value,
      strength:
        field === "newPassword"
          ? this.getPasswordStrength(value)
          : this.state.strength
    });
  };

  getPasswordStrength = (pw) => {
    const strength = zxcvbn(pw).score;
    const re = new RegExp(/[!@#$%^&*(),.?":{}|<>]/gi);
    if (re.test(pw)) {
      return strength;
    }
    return strength - 1;
  };

  enableButton = () => {
    if (
      this.state.strength === this.minStrength &&
      this.state.newPassword === this.state.verifyPassword
    ) {
      this.setState({ canSubmit: true });
    } else {
      this.setState({ canSubmit: false });
    }
  };

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  submit = (model) => {
    this.props.onSave(model.newPassword);
  };

  render() {
    const { strength } = this.state;
    const { user } = this.props;
    return (
      <React.Fragment>
        {!user.hasChangedPassword && (
          <AvatarMessage
            avatar="https://gfs-redkeep.s3.amazonaws.com/Headshots/Brian+Brunelle.jpg"
            message="Hello, Brian Brunelle here... looks like your password is weak. Mind changing it for me?"
          />
        )}
        <Formsy
          ref={(ref) => (this.form = ref)}
          className="reset form"
          onValidSubmit={this.submit}
          onValid={this.enableButton}
          onInvalid={this.disableButton}
        >
          <div className="strength-meter mt-2">
            <div className="strength-meter-fill" data-strength={strength} />
          </div>
          <Row>
            <Col md={12}>
              <Input
                formNoValidate
                required
                type="password"
                name="newPassword"
                label="Password"
                placeholder="New Password"
                autoComplete="new-password"
                onChange={this.onChange}
                value={this.state.newPassword}
              />
            </Col>
            <Col md={12}>
              <Input
                formNoValidate
                required
                type="password"
                name="verifyPassword"
                label="Verify Password"
                autoComplete="new-password"
                placeholder="Verify Password"
                validations="equalsField:newPassword"
                validationError="Passwords do not match."
                onChange={this.onChange}
                value={this.state.verifyPassword}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12} className="footer">
              <button
                className="btn  btn-cancel"
                type="button"
                onClick={this.props.onCancel}
              >
                Cancel
              </button>
              <input
                className="btn  btn-success"
                type="submit"
                disabled={!this.state.canSubmit || this.props.saving}
                value={this.props.saving ? "Saving... " : "Save"}
              />
            </Col>
          </Row>
        </Formsy>
      </React.Fragment>
    );
  }
}

ChangePassForm.propTypes = {
  onSave: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  onCancel: PropTypes.func,
  user: PropTypes.object
};

export default ChangePassForm;
